import React from "react";
import Text from "@/components/ui/text";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { getEnumTKey } from "@/utils/strings";
import { EntityType } from "@/services/hooks/entities/useEntityType";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  entity: EntityType;
  entityName: string;
  handleDelete: () => void;
}

const DeleteEntityModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  entity,
  entityName,
  handleDelete
}) => {
  const { t } = useTranslation();
  const renderConfirmation = () => {
    return t("deleteEntityModal.confirmation", {
      article: entity === EntityType.DEAL ? t("deleteEntityModal.the") : "",
      name: entityName,
      entityType:
        entity === EntityType.DEAL ? ` ${t("deleteEntityModal.deal")}` : ""
    });
  };
  return (
    <Modal
      open={isOpen}
      setIsOpen={setIsOpen}
      contentClassname="w-[35rem]"
      data-test={`delete-entity-modal-${entity}`}
      title={
        <Text
          as="div"
          variant="lgSubtitleH1"
          data-test="delete-entity-modal-title"
        >
          {`${t("deleteEntityModal.title")} ${t(
            getEnumTKey("entities", "names", EntityType, entity)
          )}`}
        </Text>
      }
      content={
        <div
          className="flex flex-col gap-3 h-fit w-[35rem] p-4"
          data-test="delete-entity-modal-content"
        >
          <Text as="div" variant="body">
            {renderConfirmation()}
          </Text>
        </div>
      }
      footer={
        <div
          className="flex justify-end gap-2"
          data-test="delete-entity-modal-footer"
        >
          <Button
            data-test="delete-entity-modal-cancel-button"
            variant="secondary"
            onClick={() => setIsOpen(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            data-test="delete-entity-modal-confirm-button"
            destructive
            onClick={handleDelete}
          >
            {t("deleteEntityModal.delete")}
          </Button>
        </div>
      }
    />
  );
};

export default DeleteEntityModal;
